import comp from "./Separator";
export default comp;
